import gql from 'graphql-tag';

const GET_INVOICE_TEMPLATE_LIST = gql`
  query getInvoiceTemplates($listInfo: ListInfoInput) {
    getInvoiceTemplates(listInfo: $listInfo) {
      templateId
      name
      description
      title
      memo
      footer
      defaultTemplate
      layoutConfiguration
      preferences
      createdTime
      createdBy {
        userId
        name
        firstName
        lastName
      }
      updatedTime
      updatedBy {
        userId
        name
        firstName
        lastName
      }
    }
  }
`;

const DELETE_INVOICE_TEMPLATE = gql`
  mutation deleteInvoiceTemplate($input: InvoiceTemplateIdentifierInput!) {
    deleteInvoiceTemplate(input: $input)
  }
`;

const GET_INVOICE_XML_FORMATS = gql`
  query getApplicableInvoiceXmlFormats {
    getApplicableInvoiceXmlFormats
  }
`;

export {
  GET_INVOICE_TEMPLATE_LIST,
  DELETE_INVOICE_TEMPLATE,
  GET_INVOICE_XML_FORMATS
};
